import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Show runtime errors on screen instead of blank page
window.addEventListener('error', (e) => {
  const root = document.getElementById('root');
  if (root && !root.hasChildNodes()) {
    root.innerHTML =
      '<div style="padding:40px;color:#fff;background:#030014;min-height:100vh">' +
      '<h1 style="color:#f88">JS Error</h1>' +
      '<pre style="color:#faa;white-space:pre-wrap;word-break:break-all">' +
      e.message + '\n\n' + (e.filename || '') + ':' + (e.lineno || '') +
      '</pre></div>';
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
